var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HTTPVerb_1 = __importDefault(require("./types/HTTPVerb"));
function getHTTPVerb(action) {
    switch (action) {
        case 'Create':
        case 'Upload':
            return HTTPVerb_1.default.POST;
        case 'Get':
            return HTTPVerb_1.default.GET;
        case 'Update':
            return HTTPVerb_1.default.PUT;
        case 'Delete':
            return HTTPVerb_1.default.DELETE;
        case 'Check':
            return HTTPVerb_1.default.HEAD;
    }
}
exports.default = getHTTPVerb;
//# sourceMappingURL=getHTTPVerb.js.map